import { render } from "./Dash.vue?vue&type=template&id=7e8efb6b&scoped=true&ts=true"
import script from "./Dash.vue?vue&type=script&lang=ts"
export * from "./Dash.vue?vue&type=script&lang=ts"

import "./Dash.vue?vue&type=style&index=0&id=7e8efb6b&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8efb6b"]])

export default __exports__